<template>
  <label :for="forId" :class="['flex items-center gap-2 text-sm leading-none font-medium select-none', className]">
    <slot />
  </label>
</template>

<script>
export default {
  name: 'BaseLabel',
  props: {
    forId: { type: String, default: '' },
    className: { type: String, default: '' },
  },
}
</script>

